import ICONS from "../../../assets/Icons";
import LICLogo from "../../../assets/landingPage/LicMutualFundsClientNewLogo.svg";
import AjemraLogo from "../../../assets/landingPage/ajmeraClientNewLogo.svg";
import ClearCorpLogo from "../../../assets/landingPage/clearCorpClientNewLogo.svg";
import LivingLiquidzLogo from "../../../assets/landingPage/livingLiquidzClientNewLogo.svg";
import "./index.css";

const allLogos = [
  { src: LICLogo, alt: "LIC Mutual Funds" },
  { src: ClearCorpLogo, alt: "ClearCorp" },
  { src: AjemraLogo, alt: "Ajmera" },
  { src: LivingLiquidzLogo, alt: "Living Liquidz" },
  {
    src: "https://static.wixstatic.com/media/35ca97_504e8706cda544a1be5336e59895997b~mv2.jpg/v1/fill/w_279,h_249,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/gsw_edited.jpg",
    alt: "GSW",
  },
  {
    src: "https://static.wixstatic.com/media/3241d3_c3c4bc63abc748b2930a326cb9e40a19~mv2.png/v1/fill/w_160,h_77,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Sugee%20Logo_Register_1-08.png",
    alt: "Sugee",
  },
  {
    src: "https://www.cpgoenkainternationalschool.com/images/cp-logo.svg",
    alt: "CP Goenka International School",
  },
  {
    src: "https://tyaani.com/cdn/shop/files/Group_34.svg?height=50&v=1735921393",
    alt: "Tyaani",
  },
  {
    src: "https://www.nuvama.com/wp-content/uploads/2022/11/Nuvama-Logo.svg",
    alt: "Nuvama",
  },
  {
    src: ICONS?.WHITEGOLD,
    alt: "White Gold",
  },
  {
    src: "https://cdn.prod.website-files.com/62e14093f115c37049b99cf9/62e40aec4a7e6654ee24e8df_Group%20125.svg",
    alt: "Client",
  },
  {
    src: "https://rehabhousing.in/wp-content/uploads/2025/06/Rahab-logo1.png",
    alt: "Rehab Housing",
  },
];

const LogoList = () => (
  <ul className="marquee__content">
    {[...allLogos, ...allLogos].map((logo, i) => (
      <li
        key={i}
        className="marquee__item"
        style={{ height: "var(--loader-lg)", aspectRatio: "3 / 1" }}
      >
        <img
          src={logo.src}
          alt={logo.alt}
          className="flex-shrink-0 bg-text-primary rounded-[10px] px-2.5 py-[5px] w-full h-full"
          style={{ objectFit: "contain" }}
        />
      </li>
    ))}
  </ul>
);

const TrustedClients = () => (
  <div className="max-w-[1024px] mx-auto py-5 w-width-full">
    <div className="text-center flex flex-col items-center overflow-hidden">
      <p className="text-font-xl text-text-primary text-center font-semibold">
        Trusted across industries, including large-scale
        <span className="text-pending">&nbsp;clients&nbsp;</span>
        such as
      </p>
      <p className="text-xs text-text-secondary py-padding-sm">
        We are committed to provide our clients with the highest quality of
        service
      </p>
      <section
        className="enable-animation"
        style={{ overflow: "hidden", width: "100%" }}
      >
        <div className="marquee">
          <LogoList />
        </div>
      </section>
    </div>
  </div>
);

export default TrustedClients;
